<script>
export default {
  install(Vue) {
    Vue.$types = new function () {
      const resolveType = function (type) {
        switch (type) {
          case 1:
          case 3:
            return "machine";
          case 2:
            return "product";
          case 4:
            return "competence";
          case 6:
            return "job";
          case 8:
            return "course";
          case 10:
            return "announcement";
          default:
            throw "Unsupported type: " + type;
        }
      }
      return {
        getTrackerTargetName: resolveType,
        getPathName: resolveType,
      };
    }
  }
}
</script>